import { routes } from 'consts'
import Actions from '../actions'
import { eventTypes, event } from '../consts/eventConsts'

export const clinicReferralNavWrapper = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(
      Actions.NAV_TO_CLINIC_REFERRAL,
      navigations?.data?.clinic_type
    )
  )
}

export const apptBeforeVisit = (dispatch, appointment_id) => {
  dispatch(
    Actions.createAction(Actions.NAV_TO_APPT_BEFORE_VISIT_FROM_NOTIFICATION, {
      appointmentId: appointment_id
    })
  )
}

export const apptBeforeVisitsWrapper = (dispatch, navigations) => {
  const appointmentId = navigations?.data?.appointment_id
  apptBeforeVisit(dispatch, appointmentId)
}

export const fuHtnBotStartRequested = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(Actions.FOLLOW_UP_HTN_BOT_START_REQUESTED, {
      invitation_id: navigations?.data?.invitation_id
    })
  )
  dispatch(
    Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
      eventName: Actions.HTN_FOLLOW_UP_BOT_LINK_OPENED
    })
  )
}

export const fuDmBotStartRequested = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(Actions.FOLLOW_UP_DM_BOT_START_REQUESTED, {
      invitation_id: navigations?.data?.invitation_id
    })
  )
  dispatch(
    Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
      eventName: Actions.DM_FOLLOW_UP_BOT_LINK_OPENED
    })
  )
}

export const fuMhBotStartRequested = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(Actions.FOLLOW_UP_MH_BOT_START_REQUESTED, {
      invitation_id: navigations?.data?.invitation_id
    })
  )
}

export const fuPrimaryHmoBotStartRequested = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(Actions.FOLLOW_UP_PRIMARY_HMO_BOT_START_REQUESTED, {
      invitation_id: navigations?.data?.invitation_id,
      intent: navigations?.data?.intent
    })
  )
}

export const markNotificationAsSeen = (
  dispatch,
  notificationId,
  notificationSeen
) => {
  if (!notificationSeen) {
    dispatch(
      Actions.createAction(Actions.NOTIFICATIONS_SEEN_REQUESTED, {
        notifications: [{ id: notificationId }]
      })
    )
  }
}

export const navToPrescription = (dispatch, navigations) => {
  const fileId = navigations?.data?.prescription_file_id
  dispatch(
    Actions.createAction(Actions.NAVIGATE_TO_PRESCRIPTION, {
      prescriptionFileId: fileId
    })
  )
}

export const navToMedicalNote = (dispatch, navigations) => {
  const fileId = navigations?.data?.medical_note_file_id
  dispatch(
    Actions.createAction(Actions.NAV_TO_MEDICAL_NOTE_FROM_NOTIFICATION, {
      medicalNoteFileId: fileId
    })
  )
}

export const navToReferralResult = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(
      Actions.QUEST_REFERRALS_RESULTS_REQUESTED_FROM_NOTIFICATION,
      {
        patientId: navigations?.data?.patient_id,
        referralResultId: navigations?.data?.referral_result_id
      }
    )
  )
}

export const navToLabReferral = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(Actions.NAV_TO_LAB_REFERRAL, {
      fileId: navigations?.data?.file_id
    })
  )
}

export const navToQuestReferral = (dispatch, navigations) => {
  dispatch(
    Actions.createAction(Actions.NAV_TO_QUEST_REFERRAL, {
      questReferralOrderId: navigations?.data?.order_id
    })
  )
}

export const navToSingleClaim = (dispatch, navigations) => {
  const claimId = navigations?.data?.claim_id
  const memberId = navigations?.data?.member_id
  if (claimId && memberId) {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        `${routes.CLAIM.replace(':claimId', claimId)}?memberId=${memberId}`
      )
    )
  }
}

export const sendNotificationAnalytics = (
  dispatch,
  navigations,
  details,
  notificationId,
  notificationSeen,
  title
) => {
  dispatch(
    Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
      type: eventTypes.click,
      eventName: event.clickEvent.click,
      data: {
        title: title,
        details: details,
        notificationId: notificationId,
        notificationSeen: notificationSeen,
        navigations: navigations
      },
      element: 'notfication_clicked'
    })
  )
}
